var _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDarkSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4442 16.833C36.5791 16.9747 36.685 17.1412 36.7558 17.3233C36.8323 17.5073 36.8725 17.7043 36.8741 17.9035H22.6325L18.6849 17.8601C18.6849 17.8601 16.5039 17.9159 14.8402 17.9159H7.40932H0.866429C0.862951 17.7168 0.90115 17.5192 0.978593 17.3357C1.05381 17.1515 1.16622 16.9846 1.30885 16.8454L7.0074 11.1703L10.6714 7.52443L17.7751 0.446812C17.9156 0.304833 18.0829 0.19199 18.2674 0.114806C18.4534 0.0392898 18.6523 0.000305317 18.8532 0C19.053 0.000704184 19.2508 0.0396813 19.4358 0.114806C19.6212 0.191922 19.7896 0.304748 19.9312 0.446812L27.0972 7.56477L30.8142 11.2479L36.4442 16.833Z",
    fill: "url(#paint0_linear_1424_4995)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3036 19.5791L19.9361 29.8321C19.6392 30.1293 19.263 30.2729 18.8592 30.2729C18.4555 30.2729 18.0682 30.1144 17.7823 29.8321L7.40239 19.5791H0.866284C0.864303 19.7767 0.902405 19.9727 0.978332 20.1554C1.05347 20.3384 1.16576 20.5041 1.30825 20.6423L17.7854 36.9171C17.9248 37.0601 18.0921 37.1733 18.2772 37.2499C18.4625 37.3268 18.6614 37.3666 18.8624 37.367C19.0633 37.3672 19.2623 37.3274 19.4475 37.2499C19.6326 37.1733 19.7999 37.0601 19.9393 36.9171L36.432 20.6423C36.5744 20.5034 36.6876 20.3379 36.765 20.1554C36.84 19.9725 36.877 19.7765 36.874 19.5791H30.3036Z",
    fill: "url(#paint1_linear_1424_4995)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2533 30.1691C19.2255 30.9645 21.4413 32.8052 22.9562 33.9642C22.9492 33.9327 19.6495 37.4226 19.4572 37.5042C19.272 37.5828 19.0729 37.6232 18.8718 37.623C18.6707 37.6226 18.4717 37.5822 18.2863 37.5042C18.1011 37.4265 17.9337 37.3116 17.7943 37.1666L1.30848 20.6576C1.16592 20.5174 1.05357 20.3493 0.978391 20.1637C0.902424 19.9783 0.864302 19.7795 0.866284 19.5791H7.4058L17.4846 29.5555C17.7107 29.76 18.1403 30.1236 18.2533 30.1691Z",
    fill: "url(#paint2_linear_1424_4995)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M24.1914 32.7375C24.159 32.77 22.9724 33.9592 22.9724 33.9592L20.6247 32.104L18.3221 30.2036L19.9617 30.7766L22.4558 31.7921L24.4042 32.5732C24.4042 32.5732 24.2817 32.647 24.1914 32.7375Z",
    fill: "url(#paint3_linear_1424_4995)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1424_4995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2892 16.7425C36.4235 16.8821 36.5289 17.0462 36.5994 17.2256C36.6756 17.407 36.7156 17.6011 36.7173 17.7973H22.5372L18.6068 17.7546C18.6068 17.7546 16.4353 17.8096 14.7787 17.8096H7.38002H0.865451C0.861988 17.6134 0.900022 17.4187 0.97713 17.2378C1.05202 17.0563 1.16395 16.8919 1.30596 16.7548L6.97984 11.1628L10.628 7.5704L17.701 0.596513C17.8408 0.456616 18.0074 0.345426 18.1911 0.269373C18.3763 0.194964 18.5743 0.156551 18.7743 0.15625C18.9733 0.156944 19.1702 0.19535 19.3544 0.269373C19.5391 0.345359 19.7067 0.456531 19.8477 0.596513L26.9827 7.61014L30.6836 11.2393L36.2892 16.7425Z",
    fill: "url(#paint4_linear_1424_4995)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1424_4995)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9785,
    height: 21.6774,
    transform: "matrix(0.728237 -0.685325 0.711818 0.702364 -0.220703 16.8271)",
    fill: "url(#paint5_linear_1424_4995)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1424_4995",
    x1: 12.151,
    y1: 10.0169,
    x2: 27.0016,
    y2: 18.3585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1424_4995",
    x1: 18.8702,
    y1: 19.5791,
    x2: 18.8702,
    y2: 37.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5712F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1424_4995",
    x1: 10.2482,
    y1: 19.5791,
    x2: 10.2482,
    y2: 37.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4141F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC9FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1424_4995",
    x1: 20.897,
    y1: 32.9638,
    x2: 21.8815,
    y2: 31.5091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F187C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4137CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1424_4995",
    x1: 12.1012,
    y1: 10.0263,
    x2: 26.8131,
    y2: 18.3766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#343761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1424_4995",
    x1: 6.26119,
    y1: 12.12,
    x2: 16.4261,
    y2: 14.7382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C7DF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkSmall);
export default __webpack_public_path__ + "static/media/logoDarkSmall.13f49229bcfc2c82374ea1f693998412.svg";
export { ForwardRef as ReactComponent };